import { render, staticRenderFns } from "./Template354.vue?vue&type=template&id=e4654b78&scoped=true&"
import script from "./Template354.vue?vue&type=script&lang=js&"
export * from "./Template354.vue?vue&type=script&lang=js&"
import style0 from "./Template354.vue?vue&type=style&index=0&id=e4654b78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4654b78",
  null
  
)

export default component.exports